// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

// Tab title mapping based on tags
const tabs_title_mapping={
  section_minimalist:"THE MINIMALIST",
  section_essentialist:"THE ESSENTIALIST",
  section_ritualist:"THE RITUALIST",
  section_minimalist_enhanced:"THE MINIMALIST",
  section_essentialist_enhanced:"THE ESSENTIALIST",
  section_ritualist_enhanced:"THE RITUALIST"
} 

const mainRecommendedGrids = ["section_minimalist", "section_essentialist", "section_ritualist","section_minimalist_enhanced", "section_essentialist_enhanced","section_ritualist_enhanced"];
    
const NON_VALID_TEXT_SECTIONS = [
    "section_ingredients"
];

const VALID_SECTION_KEYS = new Set([
    "section_minimalist_enhanced",
    "section_essentialist_enhanced",
    "section_ritualist_enhanced",
    "section_minimalist",
    "section_essentialist",
    "section_ritualist"
]);

const SECTIONS_WITH_TITLE = new Set([
    "section_minimalist_enhanced",
    "section_essentialist_enhanced",
    "section_ritualist_enhanced",
    "section_minimalist",
    "section_essentialist",
    "section_ritualist"
]);

let sections_add_to_cart_map={};
let tangent_client_domain_currency;
let currentTab;
let tangentRecommendedProducts=[];
let tangent_text_sections;

const tangent_client_domain_url = window.location.origin;

// Tabs for recommended and routine sections
const tangent_recommended_tabs = document.querySelector("#tangent_product_custom_tabs"); 
const tangent_enhanced_tabs = document.querySelector("#tangent_enhanced_custom_tabs"); 

// Main containers for recommended sections
const recommendedMinimalist = document.querySelector("#section_minimalist_recommended_container"); 
const recommendedEssentialist = document.querySelector("#section_essentialist_recommended_container"); 
const recommendedRitualist = document.querySelector("#section_ritualist_recommended_container"); 

// Main containers for routine sections
const enhancedMinimalist = document.querySelector("#section_minimalist_enhanced_container"); 
const enhancedEssentialist = document.querySelector("#section_essentialist_enhanced_container"); 
const enhancedRitualist = document.querySelector("#section_ritualist_enhanced_container"); 

const tangent_text_sections_wrapper_element = document.querySelector("#tangent_text_sections_wrapper");

const tangent_default_selfie_image_url="https://cdn.shopify.com/s/files/1/0755/5863/files/skin_quiz2-4.jpg?v=1780074966";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const selectElement = (sel, par) => (par || document).querySelector(sel),
    elPopup = selectElement("#tangent-popup-msg");
let skip_selfie = !1,
    final_tag_found;
const products_region_map = {
        final_full_glow: {
            acne: 8015954673834,
            wrinkles: 7803775025322,
            dark_spots: 7803775025322,
            rosacea: 7791720759466,
            dark_circles: 3745912291412
        },
        final_glass_skin: {
            acne: 4360103493716,
            wrinkles: 3610310180948,
            dark_spots: 4360103493716,
            rosacea: 6898198347946,
            dark_circles: 3745912291412
        },
        final_barrier_repair: {
            acne: 8015954673834,
            wrinkles: 7803775025322,
            dark_spots: 7803775025322,
            rosacea: 7791720759466,
            dark_circles: 3745912291412
        }
    },
    area_mapping = {
        forehead: ["rosacea_forehead", "dark_spots_forehead", "wrinkles_forehead", "acne_forehead"],
        left_cheek: ["rosacea_left_cheek", "dark_spots_left_cheek", "acne_left_cheek"],
        right_cheek: ["rosacea_right_cheek", "dark_spots_right_cheek", "acne_right_cheek"],
        left_eye: ["rosacea_left_eye", "dark_spots_left_eye", "acne_left_eye"],
        right_eye: ["rosacea_right_eye", "dark_spots_right_eye", "acne_right_eye"],
        left_jaw: ["dark_spots_left_jaw", "acne_left_jaw"],
        right_jaw: ["dark_spots_right_jaw", "acne_right_jaw"],
        chin: ["dark_spots_chin", "acne_chin"],
        nose: ["rosacea_nose", "dark_spots_nose", "acne_nose"],
        right_eye_under: ["wrinkles_right_eye_under", "dark_circles_right_eye_under"],
        right_eye_corner: ["wrinkles_right_eye_corner"],
        left_eye_under: ["wrinkles_left_eye_under", "dark_circles_left_eye_under"],
        left_eye_corner: ["wrinkles_left_eye_corner"],
        right_lip_corner: ["wrinkles_right_lip_corner"],
        left_lip_corner: ["wrinkles_left_lip_corner"]
    };

let condition_msg_map = [],
    final_selected_regions = [],
    tangent_all_tags;
    
const url = new URL(window.location.href),
    imgid = url.searchParams.get("id"),
    resp_id = url.searchParams.get("resp_id"),
    currentScriptUrl = document.currentScript.src,
    tangentAssetsBase = "https://cdn.shopify.com/s/files/1/0838/0117/8412/files/";

async function getResponseId() {
  return new URL(window.location.href).searchParams.get("resp_id");
}

function onLoadFunction() {
    getResponseId().then(tangent_response_id => showRecommendation(tangent_response_id)).catch(err => {
        console.log("Error: " + err)
    })
}

document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", event => {
    onLoadFunction()
}) : onLoadFunction();

async function showRecommendation(tangent_response_id) {
    if (!tangent_response_id) return;

    toggle_loader_view(true);
    changeLoadingText("Fetching your results...");

    const checkout_url =
        `https://service.tangent.ai/shopify/get-checkout-products` +
        `?resp_id=${tangent_response_id}` +
        `&self_serve=true&multiple_variants=true`;

    try {
        const response = await fetch(checkout_url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        handleRecommendationData(data);

    } catch (error) {
        console.error("Error in server call:", error);

        toggle_loader_view(false);

        show_selfie_popupmessage(
        "Something went wrong, please check your internet connection!",
        "tangent-popup-msg"
        );
    }
}

function handleRecommendationData(data) {
    if (!data) return;

    handleSelfieDisplay(data);

    tangent_product_sections = data.product_sections || [];
    tangent_text_sections = data.text_sections || [];
    tangentRecommendedProducts = data.products || [];
    tangent_all_tags = data.tags || [];

    setCurrencyFromStore();

    appendCustomerName(data);

    // Process tags
    if (tangent_all_tags.length > 0) {
        processTagsAndDisplaySelfie();
    }

    // Create product sections
    if (tangent_product_sections!=undefined) {
        createProductSection(tangent_product_sections, tangent_text_sections);
    }

    // Create text sections
    if (tangent_text_sections!=undefined) {
        createTextOnlySections(tangent_product_sections, tangent_text_sections);
    }

    for (const section_name in tangent_product_sections) {
        if(mainRecommendedGrids.includes(section_name)){
            createTabButton(section_name);
        }
    }

    // Display products
    if (tangentRecommendedProducts.length > 0) {
        setProductsToView(tangentRecommendedProducts, tangent_product_sections, data.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 

        // Setting active tab using tags
        setActiveTab(tangent_all_tags);
        renderAddAllToCartButtons(tangent_product_sections,tangent_text_sections);
        appendIngredients(tangent_text_sections);
        handleEmptySections(tangent_product_sections);
    }   
}

function handleEmptySections(product_sections){
    const recommended_sections = {
        section_minimalist_recommended: [
            "section_cleanse_reco",
            "section_serum_reco",
            "section_moist_reco"
        ],
        section_essentialist_recommended: [
            "section_cleanse_reco",
            "section_tone_reco",
            "section_serum_reco",
            "section_moist_reco",
            "section_sun_reco"
        ],
        section_ritualist_recommended: [
            "section_cleanse_reco",
            "section_tone_reco",
            "section_serum_reco",
            "section_pm_serum_reco",
            "section_eye_reco",
            "section_moist_reco",
            "section_sun_reco",
            "section_mask_reco"
        ]
    };

    Object.values(recommended_sections).flat().forEach((sectionKey) => {

        const sectionDiv = document.querySelector(`.${sectionKey}_container`);

        const hasProducts =
            sectionDiv?.querySelector('.our-prducts-box');

        if (!product_sections?.[sectionKey] || !hasProducts) {

            if (sectionDiv) {
                sectionDiv.style.display = "none";
            }
        }
    });

    document.querySelectorAll('.products-grid').forEach((grid) => {

        const visibleSections = [
            ...grid.children
        ].filter(section =>
            window.getComputedStyle(section).display !== 'none'
        );

        visibleSections.forEach((section, index) => {

            const stepTextElement = section.querySelector(
                '.product-step-count span span'
            );

            if (!stepTextElement) return;

            stepTextElement.textContent =
                stepTextElement.textContent.replace(
                    /Step\s+\d+:/,
                    `Step ${index + 1}:`
                );
        });
    });
}

function appendIngredients(textSections) {
    const incredientCards = textSections.section_ingredients;
    const container = document.getElementById("tangent-ingredients-content");
    if (!container || !Array.isArray(incredientCards)) return;

    incredientCards.forEach(cardHtml => {
        container.insertAdjacentHTML("beforeend", cardHtml);
    });
}

function renderAddAllToCartButtons(sectionProductsMap, sectionTextMap) {
    Object.keys(sectionProductsMap).forEach(sectionKey => {
        if (!VALID_SECTION_KEYS.has(sectionKey)) return;

        const sectionContainer = getSectionContainer(sectionKey);
        if (!sectionContainer) return;

        renderSectionTitle(sectionKey, sectionContainer, sectionTextMap);
        renderAddAllButton(sectionKey, sectionContainer);
    });
}

function getSectionContainer(sectionKey) {
    return document.getElementById(`${sectionKey}_container`);
}

function renderSectionTitle(sectionKey, container, sectionTextMap) {
    if (!SECTIONS_WITH_TITLE.has(sectionKey) || !sectionTextMap[sectionKey]) return;
    const titleContainer = document.createElement("div");
    titleContainer.id = `${sectionKey}_title_container`;
    titleContainer.className = `section_title_container ${sectionKey}_title_container`;
    titleContainer.innerHTML = sectionTextMap[sectionKey].join(' ');

    container.prepend(titleContainer);
}

function renderAddAllButton(sectionKey, container) {
    if (container.querySelector('.section_add_all_to_cart')) return;
    const sectionData = sections_add_to_cart_map[sectionKey];
    if (!sectionData) return;
    const total = sectionData.total;
    let discount = 0;
    if (sectionKey.includes('section_minimalist')) discount = 0.10;
    else if (sectionKey.includes('section_essentialist')) discount = 0.20;
    else if (sectionKey.includes('section_ritualist')) discount = 0.30;

    const discountedTotal = (total * (1 - discount)).toFixed(2);

    const addAllButton = document.createElement('button');
    addAllButton.id = sectionKey;
    addAllButton.className = `section_add_all_to_cart ${sectionKey}_add_all_to_cart btn`;
    addAllButton.dataset.section = sectionKey;

    addAllButton.innerHTML = `
        <span>
            <s>$${total.toFixed(2)}</s>&nbsp;
            <span>$${discountedTotal}</span>&nbsp;
            ${default_add_all_to_cart_text}
        </span>
    `;

    addAllButton.onclick = () => addAllTocartFunction(addAllButton);

    container.appendChild(addAllButton);

    const bundleNotice = document.createElement('p');
    bundleNotice.className = 'tangent-bundle-notice';
    bundleNotice.textContent = 'If any item in a bundle is unavailable, the bundle discount may not apply.';
    container.appendChild(bundleNotice);
}

function appendCustomerName(data) {
    let name = data?.form?.tangent_selfie_name;
    const nameElement = document.getElementById('tangent-customer-name');

    if (!nameElement) return;

    if (name && name.trim() !== '') {
        // Capitalize first letter
        name = name.charAt(0).toUpperCase() + name.slice(1);

        // Add possessive form
        nameElement.textContent = `${name}'s`;
    } else {
        nameElement.textContent = "Your";
    }
}

// Setting Selfie / Default Image
function setTangentDefaultSelfie() {
    const selfieImage = document.getElementById("selfie_img");
    if (tangent_default_selfie_image_url) {
        setElementDisplay("selfie_img", "flex");
        setElementDisplay("tangent_selfie_div", "flex");
        selfieImage.src = tangent_default_selfie_image_url;
    }
}

// Tab buttons 
function createTabButton(section_name) {
    const tab_button = document.createElement("button");
    tab_button.id = `${section_name}_tab_button`;
    tab_button.textContent = getTabTitle(section_name); // safer than innerHTML if text only
    tab_button.name = section_name;
    
    // Click listener
    tab_button.addEventListener("click", () => switchTab(tab_button));
    tab_button.classList.add("tablinks");
    if(section_name.includes('_enhanced')){
        tab_button.classList.add("enhanced-tablinks", `${section_name}_tab_button`);
        tangent_enhanced_tabs.appendChild(tab_button);
    }
    else{
        tab_button.classList.add("recommended-tablinks", `${section_name}_tab_button`);
        tangent_recommended_tabs.appendChild(tab_button);
    }
}

function getTabTitle(section) {
  // Use mapped title if available
  if (tabs_title_mapping && tabs_title_mapping[section] !== undefined) {
    return tabs_title_mapping[section];
  }

  // Fallback: clean up the section name
  return section
    .replace(/^section_/, "")  // Remove only prefix "section_"
    .replace(/_/g, " ")        // Replace ALL underscores with spaces
    .trim()
    .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word
}


// Handle Tab button selection
function switchTab(element) {
    let i, productTabContents,textTabContents, productTablinks, textTablinks;
    currentTab = element.name;
    if(element.name.includes("enhanced")){
        productTabContents = document.querySelectorAll(".enhanced_container");
        productTablinks = document.querySelectorAll(".enhanced-tablinks");
    }
    else{
        productTabContents = document.querySelectorAll(".recommended_container");
        productTablinks = document.querySelectorAll(".recommended-tablinks");
    }

    for (i = 0; i < productTabContents.length; i++) {
        productTabContents[i].classList.add("tabcontent");
    }
    for (i = 0; i < productTablinks.length; i++) {
        productTablinks[i].className = productTablinks[i].className.replace(" active", "");
    }
    // Display the clicked tab and set it to active.
    document.getElementById(element.name+"_container").classList.remove("tabcontent");
    document.getElementById(element.name+"_tab_button").classList.add("active");
    handleCarousel();
}


function setActiveTab(tags) {
    let activeIndex = 0;
    currentTab = "section_minimalist";

    if (tags.includes("time_10")) {
        currentTab = "section_essentialist";
        activeIndex = 1;
    } else if (tags.includes("time_15")) {
        currentTab = "section_ritualist";
        activeIndex = 2;
    }

    tangent_recommended_tabs.style.display = "flex";
    tangent_enhanced_tabs.style.display = "flex";

    activateTabGroup(
        ".recommended_container",
        ".recommended-tablinks",
        activeIndex
    );

    activateTabGroup(
        ".enhanced_container",
        ".enhanced-tablinks",
        activeIndex
    );

    handleCarousel();
}

function activateTabGroup(contentSelector, linkSelector, activeIndex) {
    const tabContents = document.querySelectorAll(contentSelector);
    const tabLinks = document.querySelectorAll(linkSelector);

    tabContents.forEach(tab => tab.classList.add("tabcontent"));
    tabLinks.forEach(link => link.classList.remove("active"));

    if (!tabContents[activeIndex] || !tabLinks[activeIndex]) return;

    tabContents[activeIndex].classList.remove("tabcontent");
    tabLinks[activeIndex].classList.add("active");
}

function handleCarousel() {
    const container = document.getElementById(`${currentTab}_products-grid`);
    if (!container) return;

    const wrapper = container.closest(".carousel-wrapper");
    if (!wrapper) return;

    const hasOverflow = container.scrollWidth > container.clientWidth;

    container.classList.toggle("center-mode", !hasOverflow);

    toggleCarouselNav(wrapper, hasOverflow);
}

function toggleCarouselNav(wrapper, showButtons) {
    wrapper.querySelectorAll(".nav-btn").forEach(btn => {
        btn.style.display = showButtons ? "block" : "none";
    });
}

function scrollProducts(direction) {
  const container = document.getElementById(currentTab+"_products-grid");

  const scrollAmount = container.clientWidth * 0.8;

  container.scrollBy({
    left: direction * scrollAmount,
    behavior: "smooth"
  });
}

function setCurrencyFromStore() {
    const currencyElement = document.querySelector("#tangent_client_currency");

    // Safely get value and trim spaces
    let currency = currencyElement?.innerText?.trim();

    // Fallback to default if empty or undefined
    tangent_client_domain_currency = currency || '$';
}

// Main Section container 
function createProductSectionContainer(section_name){
    const section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    if(section_name.includes("enhanced")){
        section_container.classList.add("product_enhanced_container")
    }
    else{
        section_container.classList.add("product_recommended_container")
    }
    return section_container;
}

function createTextSectionContainer(sectionName) {
    const container = document.createElement("div");
    
    container.id = `${sectionName}_container`;

    const isStaticSection = [
        "section_selfie",
        "section_ingredients"
    ].includes(sectionName);

    if (!isStaticSection) {
        container.classList.add("text-tabcontent");
    }

    return container;
}

const productSectionsExcluded = ["section_cleanse_reco","section_serum_reco","section_moist_reco","section_tone_reco",
    "section_sun_reco","section_pm_serum_reco","section_eye_reco","section_mask_reco",
    "section_minimalist", "section_essentialist", "section_ritualist","section_minimalist_enhanced",
    "section_essentialist_enhanced","section_ritualist_enhanced"
]

function createProductSection(product_sections, text_sections) {
    for (const section_name in product_sections) {
        if(!productSectionsExcluded.includes(section_name)){
            let parentContainer;
            let parentSection;

            const sectionContainer = createProductSectionContainer(section_name);
            if(section_name.includes("ess_enhanced")){
                parentSection = "section_essentialist_enhanced";
            }
            else if(section_name.includes("min_enhanced")){
                parentSection = "section_minimalist_enhanced";
            }
            else{
                parentSection = "section_ritualist_enhanced";
            }
            // Add text section (if exists)
            if (text_sections) {
                createSectionTextContent(text_sections, sectionContainer, section_name);
            }

            // Add product grid
            const productGrid = createSectionProductGrid(section_name);
            sectionContainer.appendChild(productGrid);

            parentContainer = document.getElementById(parentSection+"_cards_container");
            if (parentContainer) {
                parentContainer.appendChild(sectionContainer);
            }
        }
    }
}


function createSectionProductGrid(sectionName) {
    const productGrid = document.createElement("div");

    productGrid.id = `${sectionName}_product_grid`;
    productGrid.className = `section_product_grid ${sectionName}_product_grid`;

    return productGrid;
}


function createSectionTextContent(textSections, sectionContainer, sectionName) {
    if (!textSections[sectionName]) return;

    const textContainer = document.createElement("div");
    textContainer.id = `${sectionName}_text_container`;
    textContainer.className = `section_text_container ${sectionName}_text_container`;
    textContainer.innerHTML = textSections[sectionName].join(' ');

    sectionContainer.appendChild(textContainer);
}

function createTextOnlySections(productSections, textSections) {
    Object.keys(textSections).forEach(sectionName => {
        if (productSections[sectionName] || NON_VALID_TEXT_SECTIONS.includes(sectionName)) return; // skip sections with products
        
        const sectionContainer = createTextSectionContainer(sectionName);

        createSectionTextContent(
            textSections,
            sectionContainer,
            sectionName
        );

        appendTextSection(sectionName, sectionContainer);
    });
}

function appendTextSection(sectionName, sectionContainer) {
    if (sectionName === "section_selfie") {
        document
            .querySelector("#section_selfie_container_parent")
            ?.appendChild(sectionContainer);
        return;
    }

    tangent_text_sections_wrapper_element.appendChild(sectionContainer);
}

// Enabling button listeners
function enableButtonListener(){
    const buttons = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    if (!buttons.length) return;

    buttons.forEach(btn => {
        btn.addEventListener('click', function () {
            addToCart(this);
        });
    });
}

function createFormDataFromIds(idArray, element) {
  const section = element?.dataset?.section; // cleaner access

  const items = idArray.map(id => {
    const item = {
      id,
      quantity: 1
    };

    if (section != null) { // only when section is not null/undefined
      item.properties = {
        _type: section+"_add_all_to_cart_action",
        _variantIds: idArray
      };
    }

    return item;
  });

  return { items };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id],element);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list, element);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  let resultText = default_addedToCartText;

  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = resultText;
    element.classList.add("added-to-cart-style");
    openAnnmarieSidecart();
  }).catch((error) => {
        element.innerHTML = "Something wrong!";
        console.error('Error:', error);
  });
}

function openAnnmarieSidecart() {
  const openPanel = function () {
    if (window.RC && RC.sidePanel && typeof RC.sidePanel.open === "function") {
      RC.sidePanel.open("#sidecart");
    }
  };

  if (window.AMG && AMG.sidecart && typeof AMG.sidecart.refresh === "function") {
    AMG.sidecart.refresh(openPanel);
  } else {
    openPanel();
  }

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const count = cart.item_count;
      let countEl = document.querySelector(".header--cart_count");
      const cartLink = document.querySelector(".header--cart_link");

      if (!countEl && cartLink && count > 0) {
        countEl = document.createElement("span");
        countEl.className = "header--cart_count";
        cartLink.appendChild(countEl);
      }

      if (countEl) {
        countEl.textContent = count;
      }
    })
    .catch((err) => console.error("Cart fetch error:", err));
}

// Show elements after response data loads
function loadElementsOnResponseData(){
    const elements = document.querySelectorAll('.load-on-data');
    if (!elements.length) return;

    elements.forEach(el => {
        el.style.display = "block";
    });
}

function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

function enableSelfieDependedStaticElements() {
    setElementDisplay("tangent_score_description", "block");
}

function setSelfieId(id) {
    tangent_selfie_id = id;
}

function getSelfieId() {
    return tangent_selfie_id;
}

function handleSelfieDisplay(data = {}) {
  const selfieUrl = data.selfie_original_url;

  const img = document.getElementById("selfie_img");
  const cover = document.getElementById("selfie_img_cover");
  const container = document.getElementById("tangent_selfie_div");

  if (selfieUrl) {
    if (img) img.src = selfieUrl;

    if (cover) cover.style.display = "none";

    if (container) container.style.display = "flex";

    if (typeof changeLoadingText === "function") {
      changeLoadingText("Scanning your selfie...");
    }
  } else {
    skip_selfie = true;
    setTangentDefaultSelfie();
  }
}

function processTagsAndDisplaySelfie() {

    const matchedTags = Object.values(area_mapping)
        .flatMap(tags => tags.filter(tag => tangent_all_tags.includes(tag)));

    final_selected_regions = [...new Set(matchedTags)];

    checkForProduct();

    if (!condition_msg_map || !condition_msg_map.length) {
        if (!skip_selfie) {
            show_selfie_popupmessage(
                "Your selfie + skin is looking clear today! Here are the best products for your current skin-state. Feel like we missed something? Try taking your selfie again",
                "tangent-popup-msg-skip"
            );
        }

        toggle_loader_view(false);
        return;
    }

    const NON_MARKING_AREAS = [
        "left_eye",
        "right_eye",
        "left_jaw",
        "right_jaw"
    ];

    selfie.init(tangentAssetsBase)
        .then(() => {

            // Keep all detections, only remove excluded areas
            const filteredItems = condition_msg_map.filter(
                item => !NON_MARKING_AREAS.includes(item.area)
            );

            if (!filteredItems.length) {
                toggle_loader_view(false);
                return;
            }

            // Count occurrences per concern
            const counts = {};

            filteredItems.forEach(item => {
                counts[item.key] = (counts[item.key] || 0) + 1;
            });

            // Find most occurring concern
            const dominantConcern = Object.keys(counts).reduce((a,b) =>
                counts[a] >= counts[b] ? a : b
            );

            // Show concern name in text element
            addCurrentFocusArea(dominantConcern);

            // Highlight only that concern (all its regions)
            filteredItems
                .filter(item => item.key === dominantConcern)
                .forEach(item => {
                    selfie.markFacialArea(
                        canvas,
                        item.area,
                        item.msg
                    );
                });

            selfie.setAreaClickCallback(
                canvas,
                selfieAreaClicked,
                true
            );

            toggle_loader_view(false);

        })
        .catch(error => {
            console.log("Error loading model:", error);

            toggle_loader_view(false);

            show_selfie_popupmessage(
                "Something went wrong, please check your internet connection!",
                "tangent-popup-msg"
            );
        });
}

function addCurrentFocusArea(concern) {
    const parent = document.getElementById("tangent-img-container");
    if (!parent) return;

    const formattedConcern = concern
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase());

    const wrapper = document.createElement("div");
    wrapper.innerHTML = `
        <p class="tangent-current-focus-text">CURRENT FOCUS AREA</p>
        <p id="tangent-highlighted-concern">${formattedConcern}</p>
    `;

    parent.appendChild(wrapper);
}

function setProductsToView(products, sections, selected_variants) {
    tangent_selected_product_map = {};
    Object.keys(sections).forEach(section => {

            if (mainRecommendedGrids.includes(section)) return;

            const product_ids = sections[section];

            // Create a document fragment for improved performance
            const fragment = document.createDocumentFragment();
            let stepCount = 1;
            for (const id of product_ids) {
                for (let p = 0; p < tangentRecommendedProducts.length; p++) {
                    // Find product by ID
                    if (String(tangentRecommendedProducts[p].id) === id) {
                        const product = tangentRecommendedProducts[p];
                        const variant = getSelectedVariant(product, selected_variants[product.id]);
                            
                        // Track selected product variant
                        tangent_selected_product_map[product.id] = extractVariantId(variant.id);
                        
                        // Generate product HTML and append it to the fragment
                        const product_html = getProductHTML(product, p, variant, section, sections, stepCount);
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = product_html;

                        // Append the created product HTML to the fragment
                        while (tempDiv.firstChild) {
                            fragment.appendChild(tempDiv.firstChild);
                        }
                    }
                }
            }
            if(section.includes("_reco")){
                const section_grids = document.getElementsByClassName(section+"_container");

                section_grids.forEach(el => {
                    el.appendChild(fragment.cloneNode(true));
                });
            }
            else{
                const sectionGrid = document.getElementById(section+"_product_grid");
                sectionGrid.appendChild(fragment);
                
            }
    });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

const getVariantImage = (variant, product) => {
  if(variant.image?.url){
    return variant.image.url; 
  }
  else{
    return product.images.nodes[0].url
  }
  return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "ACTIVE") {
      return false;
  }
  return variant.availableForSale;
}

function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}

function getProductHTML(product, index, variant, section, sections, stepCount) {
    let enhancedProductView = false;
    if(section.includes("enhanced")){
        enhancedProductView = true;
    }
    let stepNumber =0;
    const variantId = extractVariantId(variant.id);
    
    const variant_image_url = getVariantImage(variant, product);
    const variant_product_url = `${tangent_client_domain_url}/products/${product.handle}?variant=${variantId}`;

    let variantTitle= variant.title;
    if(variantTitle=="Default Title"){
        variantTitle="";
    }

    let buttonClass="";
    let buttonText = default_addToCartText;
    if(isProductAvailable(product, variant)){
        updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section, variant);
    }
    else{
        buttonText = out_of_stock_text;
        buttonClass ="disable-button";
    }
    let product_html;
    if (enhancedProductView) {
        product_html = getEnhancedProductHTML(
            product,
            index,
            variant,
            variant_product_url,
            variant_image_url,
            variantTitle,
            stepNumber,
            buttonClass,
            buttonText,
            variantId
        );
    }
    else {
        product_html = getRecommendedProductHTML(
            product,
            index,
            variant,
            variant_product_url,
            variant_image_url,
            variantTitle,
            stepNumber,
            buttonClass,
            buttonText,
            section,
            variantId
        );
    }
    return product_html;
}

function getEnhancedProductHTML(
    product,
    index,
    variant,
    variant_product_url,
    variant_image_url,
    variantTitle,
    stepNumber,
    buttonClass,
    buttonText,
    variantId
){
    const metaEnhancementContent = product?.tangent_enhancement_content?.value || '';
    const metaEnhancementHeading = product?.tangent_enhancement_heading?.value || '';
    return `
        ${metaEnhancementHeading}
        <div class="horizontal-prducts-box">
            <div class="tangent-product-image-container">
                <a id="url_tangent_product_${index}"
                   class="tangent-text-link"
                   target="_blank"
                   href="${variant_product_url}">
                    <img
                        id="image_tangent_product_${index}"
                        src="${variant_image_url}"
                        class="tangent_product_image"
                        alt="${product.title}">
                </a>
            </div>

            <div>
                ${metaEnhancementContent}
                <h4 class="tangent-product-title tangent_product_title_text">
                    ${product.title}
                </h4>

                <p class="tangent_variant_title">
                    ${variantTitle}
                </p>

                <div class="tangent-product-content">
                    <p
                        id="price_tangent_product_${index}"
                        class="tangent_product_price_text grid-product__price--current"
                    >
                        ${tangent_client_domain_currency}${variant.price}
                    </p>

                    <button
                        class="add clearfix addtocart quick-add-btn js-quick-add-btn tangent-product-add-btn-wrapper tangent_add_to_cart_button product-buy-buttons--cta ${buttonClass}"
                        id="${variantId}"
                        data-add-to-cart="${variantId}">
                        ${buttonText}
                    </button>
                </div>
            </div>
        </div>
    `;
}

function getRecommendedProductHTML(
    product,
    index,
    variant,
    variant_product_url,
    variant_image_url,
    variantTitle,
    stepNumber,
    buttonClass,
    buttonText,
    sectionName,
    variantId
){
    return `
        <div class="our-prducts-box">
            <div>
                <div class="tangent-product-image-container">
                    <a id="url_tangent_product_${index}"
                       class="tangent-text-link"
                       target="_blank"
                       href="${variant_product_url}">
                        <img
                            id="image_tangent_product_${index}"
                            src="${variant_image_url}"
                            class="tangent_product_image"
                            alt="${product.title}">
                    </a>
                </div>

                <div>
                    <h4 class="tangent-product-title tangent_product_title_text">
                        ${product.title}
                    </h4>

                    <p class="tangent_variant_title">
                        ${variantTitle}
                    </p>
                </div>
            </div>

            <div class="tangent-product-content">
                <p
                    id="price_tangent_product_${index}"
                    class="tangent_product_price_text grid-product__price--current"
                >
                    ${tangent_client_domain_currency}${variant.price}
                </p>

                <button
                    class="add clearfix addtocart quick-add-btn js-quick-add-btn tangent-product-add-btn-wrapper tangent_add_to_cart_button product-buy-buttons--cta ${buttonClass}"
                    id="${variantId}"
                    data-add-to-cart="${variantId}">
                    ${buttonText}
                </button>
            </div>
        </div>
    `;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(productSections, productId, variantId, sectionName, variant) {
    if (!productSections) return;

    Object.entries(productSections).forEach(([sectionKey, productIds]) => {
        if (!productIds.includes(String(productId))) return;

        const sectionData = sections_add_to_cart_map[sectionKey] ||= {
            count: 0,
            total: 0,
            cart_link: `${tangent_client_domain_url}/cart/add?`,
            list: []
        };

        if (sectionData.list.includes(variantId)) return;
        sectionData.count++;
        sectionData.list.push(variantId);
        sectionData.total += parseFloat(variant.price || 0);
        sectionData.cart_link += `&id[]=${variantId}`;
    });
}

function toggle_loader_view(flag) {
    const loaderEl = document.getElementById("tangent-selfie-loader");
    if (!loaderEl) {
        console.warn("Loader element #tangent-selfie-loader not found");
        return
    }
    loaderEl.style.display = flag ? "flex" : "none", loaderEl.setAttribute("aria-busy", flag ? "true" : "false")
}

function changeLoadingText(txt) {
    const loadingTextEl = document.getElementById("loading_text");
    if (!loadingTextEl) {
        console.warn("Loading text element #loading_text not found");
        return
    }
    loadingTextEl.textContent = String(txt ?? "")
}


function show_selfie_popupmessage(message, id) {
    const popup_element = document.getElementById(id);
    if (!popup_element) {
        console.warn(`Popup element #${id} not found`);
        return
    }
    popup_element.textContent = message ?? "";
    const container = selectElement("#tangent_selfie_div"),
        left = container ? container.offsetLeft : 0;
    Object.assign(popup_element.style, {
        top: "-95px",
        display: "block",
        maxWidth: "400px",
        border: "1px solid #cccccc",
        left: `${left}px`
    })
}

function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

function checkForProduct() {
    condition_msg_map = [];
    const pdt_map = products_region_map["final_glass_skin"];
    if (!pdt_map || !final_selected_regions?.length) return;
    const NON_MARKING_PREFIXES = ["left_eye", "right_eye", "left_jaw", "right_jaw"],
        CONDITION_CONFIG = {
            acne: {
                key: "acne",
                text: "Prone to acne here?"
            },
            wrinkles: {
                key: "wrinkles",
                text: "Prone to wrinkles here?"
            },
            rosacea: {
                key: "rosacea",
                text: "Prone to rosacea here?"
            },
            dark_spots: {
                key: "dark_spots",
                text: "Prone to dark spots here?"
            },
            dark_circles: {
                key: "dark_circles",
                text: "Prone to dark circles here?"
            }
        };
    final_selected_regions.forEach(region => {
        const condition = Object.values(CONDITION_CONFIG)
            .find(cfg => region.startsWith(cfg.key + "_"));

        if (!condition) return;

        const area = region.replace(condition.key + "_", "");

        if (
            NON_MARKING_PREFIXES.some(prefix => area.includes(prefix)) &&
            condition.key !== "dark_circles"
        ) return;

        const productLink = `<a href="/products/" target="_blank">Product Name</a>`;

        condition_msg_map.push({
            area,
            key: condition.key,
            msg: `<p>
                ${condition.text}
            </p>`
        });
    });
}

function getProductUsingId(id) {
    return Array.isArray(tangentRecommendedProducts) && tangentRecommendedProducts.find(product => product.id == id) || null
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

class TangentSelfie {
    areasToMarkArray = [];
    FILL_COLOR = "rgba(255, 255, 255, 0.2)";
    STROKE_COLOR = "rgba(255, 255, 255, 0.6)";
    STROKE_HIGHLIGHT_COLOR = "rgba(255, 255, 255, 1)";
    UNDER_EYE_BAGS_HEIGHT = 15;
    CHIN_AREA_HEIGHT = 20;
    MOUTH_WRINKLES_WIDTH = 10;
    EYE_WRINKLE_MIN_WIDTH = 10;
    EYE_WRINKLE_MAX_WIDTH = 15;
    CHEEK_WIDTH_CUTOFF = 30;
    UNDER_EYE_BAGS_WIDTH_CUTTOFF = 20;
    CHEEK_MAX_WIDTH = 35;
    CHEEK_MAX_HEIGHT = 35;
    FOREHEAD_MAX_WIDTH = 55;
    FOREHEAD_MAX_HEIGHT = 30;
    constructor(imgId) {
        this.img = document.getElementById(imgId)
    }
    async init(assetsBaseUrl) {
        try {
            await this.imageLoad(this.img), await this.sleep(2e3);
            const options = new faceapi.SsdMobilenetv1Options({
                minConfidence: .2
            });
            await faceapi.loadSsdMobilenetv1Model(assetsBaseUrl), await faceapi.loadFaceLandmarkModel(assetsBaseUrl), this.faceLandmarks = await faceapi.detectSingleFace(this.img, options).withFaceLandmarks(), this.detection = this.faceLandmarks.detection
        } catch (e) {
            console.log(e)
        }
        if (!this.detection) throw new Error("Detection was not found")
    }
    async imageLoad(imgElem) {
        return new Promise(res => {
            if (imgElem.complete) return res();
            imgElem.onload = () => res(), imgElem.onerror = () => res()
        })
    }
    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }
    get imgWidth() {
        return this.detection.imageWidth
    }
    get imgHeight() {
        return this.detection.imageHeight
    }
    getAngleToFaceRightInRadians() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye(),
            rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const theta = this.getAngleWithXAxisInRadians(leftEyePoints[0], rightEyePoints[0]);
        return theta < Math.PI / 2 ? theta : theta - Math.PI
    }
    getAngleToFaceLeftInRadians() {
        return this.getAngleToFaceRightInRadians() - Math.PI
    }
    getAngleToFaceDownInRadians() {
        return this.getAngleToFaceRightInRadians() + Math.PI / 2
    }
    getAngleToFaceUpInRadians() {
        return this.getAngleToFaceDownInRadians() - Math.PI
    }
    getLeftEyeHeight() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        const h1 = this.getDistanceBetweenPoints(leftEyePoints[1], leftEyePoints[5]),
            h2 = this.getDistanceBetweenPoints(leftEyePoints[2], leftEyePoints[4]);
        return Math.max(h1, h2)
    }
    getLeftEyeWidth() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyePoints[3])
    }
    getRightEyeHeight() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const h1 = this.getDistanceBetweenPoints(rightEyePoints[1], rightEyePoints[5]),
            h2 = this.getDistanceBetweenPoints(rightEyePoints[2], rightEyePoints[4]);
        return Math.max(h1, h2)
    }
    getLeftCrowFeetHeight() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye(),
            leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow();
        return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyeBrowPoints[1])
    }
    getRightCrowFeetHeight() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye(),
            rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow();
        return this.getDistanceBetweenPoints(rightEyePoints[3], rightEyeBrowPoints[3])
    }
    getRightEyeWidth() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        return this.getDistanceBetweenPoints(rightEyePoints[0], rightEyePoints[3])
    }
    getLeftCrowFeetWidth() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye(),
            jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline();
        return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(leftEyePoints[0], jawOutlinePoints[0]))
    }
    getRightCrowFeetWidth() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye(),
            jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline();
        return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(rightEyePoints[3], jawOutlinePoints[16]))
    }
    getNoseWidth() {
        let nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(nosePoints[4], nosePoints[8])
    }
    getNoseHeight() {
        let nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(nosePoints[0], nosePoints[6])
    }
    getMouthWidth() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        return this.getDistanceBetweenPoints(mouthPoints[0], mouthPoints[6])
    }
    getMouthHeight() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        return this.getDistanceBetweenPoints(mouthPoints[3], mouthPoints[9])
    }
    getForeheadWidth() {
        let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow(),
            rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow();
        return this.getDistanceBetweenPoints(leftEyeBrowPoints[2], rightEyeBrowPoints[2])
    }
    getForeheadHeight() {
        let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow(),
            rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow(),
            faceTopPt = this.getToptMostPt(this.getFaceBounds());
        const h1 = leftEyeBrowPoints[2]._y - faceTopPt._y,
            h2 = rightEyeBrowPoints[2]._y - faceTopPt._y;
        return Math.min(h1, h2)
    }
    getLeftCheekWidth() {
        let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline(),
            nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(jawOutlinePoints[3], nosePoints[4])
    }
    getRightCheekWidth() {
        let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline(),
            nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(jawOutlinePoints[13], nosePoints[8])
    }
    getCheekHeight() {
        return this.getNoseHeight() - this.UNDER_EYE_BAGS_HEIGHT
    }
    getChinWidth() {
        let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline();
        return this.getDistanceBetweenPoints(jawOutlinePoints[7], jawOutlinePoints[9])
    }
    getChinHeight() {
        return this.CHIN_AREA_HEIGHT
    }
    getFaceBounds() {
        const leftX = this.detection._box._x,
            rightX = this.detection._box._x + this.detection._box._width,
            topY = this.detection._box._y,
            bottomY = this.detection._box._y + this.detection._box._height;
        return [{
            _x: leftX,
            _y: topY
        }, {
            _x: rightX,
            _y: bottomY
        }]
    }
    getForeheadBounds() {
        let foreheadWidth = this.getForeheadWidth(),
            foreheadLeftRightPadding = 0;
        foreheadWidth > this.FOREHEAD_MAX_WIDTH && (foreheadLeftRightPadding = (foreheadWidth - this.FOREHEAD_MAX_WIDTH) / 2, foreheadWidth = this.FOREHEAD_MAX_WIDTH);
        let foreheadHeight = this.getForeheadHeight(),
            foreheadTopBottomPadding = 0;
        foreheadHeight > this.FOREHEAD_MAX_HEIGHT && (foreheadTopBottomPadding = (foreheadHeight - this.FOREHEAD_MAX_HEIGHT) / 2, foreheadHeight = this.FOREHEAD_MAX_HEIGHT);
        const leftBrowPt = this.faceLandmarks.landmarks.getLeftEyeBrow()[2],
            leftPaddingPt = this.getPointAtDistanceAndAngle(leftBrowPt, foreheadLeftRightPadding, this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, foreheadTopBottomPadding, this.getAngleToFaceUpInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadWidth, this.getAngleToFaceRightInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftUnderEyeBounds() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        const leftTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftEyeHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getLeftEyeWidth(), this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightUnderEyeBounds() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[0], this.getRightEyeHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightEyeWidth(), this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftCrowFeetBounds() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        const rightBottomPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight() / 2, this.getAngleToFaceUpInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians());
        return [this.getPointAtDistanceAndAngle(rightTopPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightCrowFeetBounds() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight() / 2, this.getAngleToFaceUpInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getNoseBounds() {
        const leftBottomPt = this.faceLandmarks.landmarks.getNose()[4],
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseWidth(), this.getAngleToFaceRightInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians());
        return [this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftCheekBounds() {
        let cheekWidth = this.getLeftCheekWidth(),
            cheekLeftRightPadding = 0;
        cheekWidth > this.CHEEK_MAX_WIDTH && (cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH) / 2, cheekWidth = this.CHEEK_MAX_WIDTH);
        let cheekHeight = this.getCheekHeight(),
            cheekTopBottomPadding = 0;
        cheekHeight > this.CHEEK_MAX_HEIGHT && (cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT) / 2, cheekHeight = this.CHEEK_MAX_HEIGHT);
        const leftJawPt = this.faceLandmarks.landmarks.getJawOutline()[3],
            leftPaddingPt = this.getPointAtDistanceAndAngle(leftJawPt, cheekLeftRightPadding, this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekWidth, this.getAngleToFaceRightInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightCheekBounds() {
        let cheekWidth = this.getRightCheekWidth(),
            cheekLeftRightPadding = 0;
        cheekWidth > this.CHEEK_MAX_WIDTH && (cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH) / 2, cheekWidth = this.CHEEK_MAX_WIDTH);
        let cheekHeight = this.getCheekHeight(),
            cheekTopBottomPadding = 0;
        cheekHeight > this.CHEEK_MAX_HEIGHT && (cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT) / 2, cheekHeight = this.CHEEK_MAX_HEIGHT);
        const rightJawPt = this.faceLandmarks.landmarks.getJawOutline()[13],
            rightPaddingPt = this.getPointAtDistanceAndAngle(rightJawPt, cheekLeftRightPadding, this.getAngleToFaceLeftInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(rightPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekWidth, this.getAngleToFaceLeftInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getChinBounds() {
        const leftBottomPt = this.faceLandmarks.landmarks.getJawOutline()[7],
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinWidth(), this.getAngleToFaceRightInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftMouthWrinkleBounds() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        const rightBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[0], this.getMouthHeight() / 2, this.getAngleToFaceDownInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceLeftInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians());
        return [this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightMouthWrinkleBounds() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        const leftBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[6], this.getMouthHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceRightInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians());
        return [this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getDistanceBetweenPoints(p1, p2) {
        return Math.sqrt(Math.pow(p1._x - p2._x, 2) + Math.pow(p1._y - p2._y, 2))
    }
    getMidpointBetweenPoints(p1, p2) {
        return {
            _x: Math.abs((p1._x + p2._x) / 2),
            _y: Math.abs((p1._y + p2._y) / 2)
        }
    }
    getAngleWithXAxisInRadians(p1, p2) {
        let dy = p1._y - p2._y,
            dx = p1._x - p2._x,
            theta = Math.atan2(dy, dx);
        return theta < 0 && (theta += Math.PI), theta
    }
    getPointAtDistanceAndAngle(sourcePt, distance, angle) {
        return {
            _x: sourcePt._x + distance * Math.cos(angle),
            _y: sourcePt._y + distance * Math.sin(angle)
        }
    }
    getLeftMostPt(pointsArray) {
        let leftMost = null;
        for (let i = 0; i < pointsArray.length; i++)(leftMost == null || pointsArray[i]._x < leftMost._x) && (leftMost = pointsArray[i]);
        return leftMost
    }
    getRightMostPt(pointsArray) {
        let rightMost = null;
        for (let i = 0; i < pointsArray.length; i++)(rightMost == null || pointsArray[i]._x > rightMost._x) && (rightMost = pointsArray[i]);
        return rightMost
    }
    getToptMostPt(pointsArray) {
        let topMost = null;
        for (let i = 0; i < pointsArray.length; i++)(topMost == null || pointsArray[i]._y < topMost._y) && (topMost = pointsArray[i]);
        return topMost
    }
    isPointInsidePoligon(pt, points) {
        for (var x = pt._x, y = pt._y, inside = !1, i = 0, j = points.length - 1; i < points.length; j = i++) {
            var xi = points[i]._x,
                yi = points[i]._y,
                xj = points[j]._x,
                yj = points[j]._y,
                intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
            intersect && (inside = !inside)
        }
        return inside
    }
    clearCanvas(canvas2) {
        const ctx = canvas2.getContext("2d");
        ctx.resetTransform(), ctx.clearRect(0, 0, canvas2.width, canvas2.height)
    }
    scaleCanvas(canvas2) {
        var ctx = canvas2.getContext("2d");
        ctx.resetTransform(), ctx.scale(canvas2.width / this.imgWidth, canvas2.height / this.imgHeight)
    }
    scaleUpPt(originalPt, canvas2) {
        const canvasWidth = canvas2.getBoundingClientRect().width,
            canvasHeight = canvas2.getBoundingClientRect().height;
        return {
            _x: canvasWidth * originalPt._x / this.imgWidth,
            _y: canvasHeight * originalPt._y / this.imgHeight
        }
    }
    scaleBackPt(scaledPt, canvas2) {
        const canvasWidth = canvas2.getBoundingClientRect().width,
            canvasHeight = canvas2.getBoundingClientRect().height;
        return {
            _x: this.imgWidth * scaledPt._x / canvasWidth,
            _y: this.imgHeight * scaledPt._y / canvasHeight
        }
    }
    applyCanvasStrokeColor(canvas2, color) {
        var ctx = canvas2.getContext("2d");
        ctx.strokeStyle = color
    }
    setStrokeColor(color) {
        this.STROKE_COLOR = color
    }
    setHighlightStrokeColor(color) {
        this.STROKE_HIGHLIGHT_COLOR = color
    }
    setAreaClickCallback(canvas2, callback, setFirstAutoClick = !1) {
        if (this.areaClickCallback = callback, setFirstAutoClick && this.areasToMarkArray.length > 0) {
            this.areasToMarkArray[0].clicked = !0, this.drawAllShapes(canvas2);
            const scaledPt = this.scaleUpPt(this.areasToMarkArray[0].points[0], canvas2);
            this.areaClickCallback(this.areasToMarkArray[0].area, this.areasToMarkArray[0].messageOnClick, scaledPt._x, scaledPt._y)
        }
    }
    appendAreaToArray(area, points, messageOnClick) {
        this.areasToMarkArray.push({
            area,
            points,
            messageOnClick
        })
    }
    markFacialArea(canvas2, area, messageOnClick) {
        let points = null;
        switch (area) {
            case "forehead":
                points = this.getForeheadBounds();
                break;
            case "left_eye_under":
                points = this.getLeftUnderEyeBounds();
                break;
            case "right_eye_under":
                points = this.getRightUnderEyeBounds();
                break;
            case "left_eye_corner":
                points = this.getLeftCrowFeetBounds();
                break;
            case "right_eye_corner":
                points = this.getRightCrowFeetBounds();
                break;
            case "nose":
                points = this.getNoseBounds();
                break;
            case "left_cheek":
                points = this.getLeftCheekBounds();
                break;
            case "right_cheek":
                points = this.getRightCheekBounds();
                break;
            case "left_lip_corner":
                points = this.getLeftMouthWrinkleBounds();
                break;
            case "right_lip_corner":
                points = this.getRightMouthWrinkleBounds();
                break;
            case "chin":
                points = this.getChinBounds();
                break
        }
        points != null && (this.appendAreaToArray(area, points, messageOnClick), this.drawAllShapes(canvas2))
    }
    drawAllShapes(canvas2) {
        this.clearCanvas(canvas2), this.applyCanvasStrokeColor(canvas2, this.STROKE_COLOR);
        for (let i = 0; i < this.areasToMarkArray.length; i++) {
            var isClicked = "clicked" in this.areasToMarkArray[i];
            this.drawSingleShape(canvas2, this.areasToMarkArray[i].area, this.areasToMarkArray[i].points, isClicked)
        }
        this.clickListener && canvas2.removeEventListener("click", this.clickListener, !0), this.clickListener = this.canvasClickListener.bind(this), canvas2.addEventListener("click", this.clickListener, !0)
    }
    drawSingleShape(canvas2, area, points, clicked) {
        switch (area) {
            case "forehead":
                this.drawForehead(canvas2, area, points, clicked);
                break;
            case "left_eye_under":
                this.drawUnderEyeBags(canvas2, area, points, clicked);
                break;
            case "right_eye_under":
                this.drawUnderEyeBags(canvas2, area, points, clicked);
                break;
            case "left_eye_corner":
                this.drawEyeWrinkles(canvas2, area, points, clicked);
                break;
            case "right_eye_corner":
                this.drawEyeWrinkles(canvas2, area, points, clicked);
                break;
            case "nose":
                this.drawNose(canvas2, area, points, clicked);
                break;
            case "left_cheek":
                this.drawCheeks(canvas2, area, points, clicked);
                break;
            case "right_cheek":
                this.drawCheeks(canvas2, area, points, clicked);
                break;
            case "left_lip_corner":
                this.drawMouthWrinkles(canvas2, area, points, clicked);
                break;
            case "right_lip_corner":
                this.drawMouthWrinkles(canvas2, area, points, clicked);
                break;
            case "chin":
                this.drawChin(canvas2, area, points, clicked);
                break
        }
    }
    getCursorPosition(canvas2, event) {
        const rect = canvas2.getBoundingClientRect(),
            x = event.clientX - rect.left,
            y = event.clientY - rect.top;
        return {
            _x: x,
            _y: y
        }
    }
    canvasClickListener(event) {
        let canvas2 = event.target || event.srcElement;
        const clickPt = this.getCursorPosition(canvas2, event);
        let shapeClickedIndex = -1;
        for (let i = 0; i < this.areasToMarkArray.length; i++) shapeClickedIndex == -1 && this.isPointInsidePoligon(this.scaleBackPt(clickPt, canvas2), this.areasToMarkArray[i].points) ? (shapeClickedIndex = i, this.areasToMarkArray[i].clicked = !0) : "clicked" in this.areasToMarkArray[i] && delete this.areasToMarkArray[i].clicked;
        this.drawAllShapes(canvas2), this.areaClickCallback && (shapeClickedIndex == -1 ? this.areaClickCallback(null, null, clickPt._x, clickPt._y) : this.areaClickCallback(this.areasToMarkArray[shapeClickedIndex].area, this.areasToMarkArray[shapeClickedIndex].messageOnClick, clickPt._x, clickPt._y))
    }
    drawForehead(canvas2, area, points, clicked) {
        this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawUnderEyeBags(canvas2, area, points, clicked) {
        area == "left_eye_under" && this.getLeftEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_eye_under" && this.getRightEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawNose(canvas2, area, points, clicked) {
        this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawCheeks(canvas2, area, points, clicked) {
        area == "left_cheek" && this.getLeftCheekWidth() > this.CHEEK_WIDTH_CUTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_cheek" && this.getRightCheekWidth() > this.CHEEK_WIDTH_CUTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawChin(canvas2, area, points, clicked) {
        this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawMouthWrinkles(canvas2, area, points, clicked) {
        area == "left_lip_corner" && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_lip_corner" && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawEyeWrinkles(canvas2, area, points, clicked) {
        area == "left_eye_corner" && this.getLeftCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_eye_corner" && this.getRightCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawDetections(canvas2) {
        this.scaleCanvas(canvas2), faceapi.draw.drawDetections(canvas2, this.detection)
    }
    drawLandmarks(canvas2) {
        this.scaleCanvas(canvas2), faceapi.draw.drawFaceLandmarks(canvas2, this.faceLandmarks)
    }
    drawPolygonOnCanvas(canvas2, points) {
        this.scaleCanvas(canvas2);
        var ctx = canvas2.getContext("2d");
        for (let i = 0; i < points.length - 1; i++) ctx.beginPath(), ctx.moveTo(points[i]._x, points[i]._y), ctx.lineTo(points[i + 1]._x, points[i + 1]._y), ctx.stroke();
        ctx.beginPath(), ctx.moveTo(points[points.length - 1]._x, points[points.length - 1]._y), ctx.lineTo(points[0]._x, points[0]._y), ctx.stroke()
    }
    drawRectangleOnCanvas(canvas2, rectanglePoints) {
        this.scaleCanvas(canvas2);
        var ctx = canvas2.getContext("2d");
        ctx.beginPath(), ctx.rect(rectanglePoints[0]._x, rectanglePoints[0]._y, rectanglePoints[1]._x - rectanglePoints[0]._x, rectanglePoints[1]._y - rectanglePoints[0]._y), ctx.stroke()
    }
    drawEllipseOnCanvas(canvas2, rectanglePoints, tiltInRadians = 0, clicked) {
        this.scaleCanvas(canvas2);
        let p1 = rectanglePoints[0],
            p2 = rectanglePoints[1],
            p3 = rectanglePoints[2],
            p4 = rectanglePoints[3],
            d1 = this.getDistanceBetweenPoints(p1, p2) / 2,
            d2 = this.getDistanceBetweenPoints(p1, p4) / 2,
            m = this.getMidpointBetweenPoints(p1, p3);
        var ctx = canvas2.getContext("2d");
        ctx.beginPath(), ctx.ellipse(m._x, m._y, d2, d1, tiltInRadians, 0, Math.PI * 2), clicked ? ctx.strokeStyle = this.STROKE_HIGHLIGHT_COLOR : ctx.strokeStyle = this.STROKE_COLOR, ctx.fillStyle = this.FILL_COLOR, ctx.fill(), ctx.stroke()
    }
}

function selfieAreaClicked(area, message, x, y) {
    const popup = document.getElementById("tangent-popup-msg");

    if (!area) {
        popup.style.display = "none";
        return;
    }

    popup.innerHTML = message;
    popup.style.display = "block";

    const OFFSET = 10;
    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    let left = x;
    let top = y;

    // Prevent overflow (right & bottom)
    if (left + popupWidth > window.innerWidth) {
        left = window.innerWidth - popupWidth - OFFSET;
    }

    if (top + popupHeight > window.innerHeight) {
        top = window.innerHeight - popupHeight - OFFSET;
    }

    // Prevent negative (optional safety)
    if (left < 0) left = OFFSET;
    if (top < 0) top = OFFSET;

    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
}

const canvas = document.getElementById("selfie_canvas");
let selfie = new TangentSelfie("selfie_img");